/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';

export interface OrganizationsUpdateById$Params {

/**
 * The ID of the organization to update
 */
  organizationId: string;
      body: ApiDefOrganizationData
}

export function organizationsUpdateById(http: HttpClient, rootUrl: string, params: OrganizationsUpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefOrganizationData>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateById.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefOrganizationData>;
    })
  );
}

organizationsUpdateById.PATH = '/organizations/{organizationId}';
